import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["mainDashboard", "list", "view", "3333", "4444", "5555", "6666", "7777", "8888", "9999"]

  connect() {
    this.controllerName = `operations--products--clinics--regularizations--activities--dashboard`
  }

  doActivitiesDashboard() {
    var html = `<div class="row" data-${this.controllerName}-target="mainDashboard">
                  <div class="col-7 pr-1" data-${this.controllerName}-target="list" data-controller="operations--products--clinics--regularizations--activities--index">Atividade</div>
                  <div class="col-5 pl-1" data-${this.controllerName}-target="view" data-controller="operations--products--clinics--regularizations--activities--save operations--products--clinics--regularizations--activities--show"></div>
                </div>`

    // this.getControllerByIdentifier("operations--products--clinics--regularizations--show--main").contentTarget.innerHTML = html
    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier(`operations--products--clinics--regularizations--show--main`).contentTarget.innerHTML = html)
    }).then(() => {
      controller.getControllerByIdentifier(`operations--products--clinics--regularizations--show--submenu`).dashboardToggleBtn(`ATIVIDADES ECONÔMICAS`)

      controller.getControllerByIdentifier(`operations--products--clinics--regularizations--activities--index`).permission = `medclinic_regularization_activities`
      controller.getControllerByIdentifier(`operations--products--clinics--regularizations--activities--show`).permission = `medclinic_regularization_activities`
      controller.getControllerByIdentifier(`operations--products--clinics--regularizations--activities--save`).permission = `medclinic_regularization_activities`

      controller.getControllerByIdentifier(`operations--products--clinics--regularizations--activities--index`).doIndexListHtml()
      controller.getControllerByIdentifier(`operations--products--clinics--regularizations--activities--show`).doViewHtml()
    }) 
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
